import { useAuth0 } from '@auth0/auth0-react';
import { useMutation } from '@tanstack/react-query';

import { generateBulkOperation } from '../apis/bulkOperationApi';

import { useInvalidateBulkOperation } from './useInvalidateImport';

/**
 * Hook for generating booking data for all receipts in a bulk operation (async, returns 202)
 */
export const useGenerateAllBookings = (bulkOperationId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const { invalidateAll } = useInvalidateBulkOperation(bulkOperationId);

  const generateBookingDataMutation = useMutation({
    mutationFn: async () => {
      const token = await getAccessTokenSilently();
      return generateBulkOperation(bulkOperationId, token);
    },
    onSuccess: () => {
      invalidateAll();
    },
  });

  return {
    generateAllBookings: generateBookingDataMutation.mutateAsync,
    isGeneratingAll: generateBookingDataMutation.isPending,
    generateAllError: generateBookingDataMutation.error?.message || null,
  };
};
